(() => {
  const INTERVAL = 3000;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const init = (root) => {
    if (root.dataset.aeyaBannerReady) return;
    root.dataset.aeyaBannerReady = 'true';

    const track = root.querySelector('[data-track]');
    const dots = Array.from(root.querySelectorAll('[data-dot]'));
    const slides = root.querySelectorAll('.aeya-image-banner__slide');
    if (!track || slides.length < 2) return;

    let index = 0;
    let timer = null;

    const page = () => {
      const first = slides[0];
      return first ? first.getBoundingClientRect().width : track.clientWidth;
    };

    const syncDots = () => {
      dots.forEach((dot, i) => dot.setAttribute('aria-selected', i === index ? 'true' : 'false'));
    };

    const goTo = (i, smooth = true) => {
      index = (i + slides.length) % slides.length;
      track.scrollTo({ left: page() * index, behavior: smooth ? 'smooth' : 'auto' });
      syncDots();
    };

    const stop = () => {
      if (timer) { clearInterval(timer); timer = null; }
    };

    const start = () => {
      if (reduceMotion) return;
      stop();
      timer = setInterval(() => goTo(index + 1), INTERVAL);
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        goTo(Number(dot.dataset.dot));
        start();
      });
    });

    let scrollRaf = null;
    track.addEventListener('scroll', () => {
      if (scrollRaf) return;
      scrollRaf = requestAnimationFrame(() => {
        scrollRaf = null;
        const current = Math.round(track.scrollLeft / page());
        if (current !== index && current >= 0 && current < slides.length) {
          index = current;
          syncDots();
        }
      });
    }, { passive: true });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    window.addEventListener('resize', () => goTo(index, false));

    syncDots();
    start();
  };

  const boot = () => document.querySelectorAll('.aeya-image-banner').forEach(init);

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('.aeya-image-banner');
    if (root) init(root);
  });
})();
